export enum FuelPricingDate {
    MONTHLY_AVERAGE = 'MONTHLY_AVERAGE',
    ETA = 'ETA',
    DELIVERY_DATE = 'DELIVERY_DATE',
    ORDER_DATE = 'ORDER_DATE',
}
